export default __webpack_public_path__ + "static/media/wallet01.3c9f164f.png";